var _path, _ellipse, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChurch4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 1080,
    viewBox: "0 0 1920 1080",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M483 278L483 306",
    stroke: "#F2DCCE",
    strokeWidth: 2
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 483.5,
    cy: 273.333,
    rx: 16.5,
    ry: 16.3333,
    fill: "#F2DCCE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M478.987 273.19C478.987 269.283 482.288 266.117 486.358 266.117C486.943 266.117 487.511 266.184 488.056 266.308C486.742 265.48 485.187 265 483.519 265C478.814 265 475 268.806 475 273.5C475 278.194 478.814 282 483.519 282C485.814 282 487.895 281.093 489.427 279.62C488.492 280.032 487.454 280.263 486.358 280.263C482.288 280.263 478.987 277.096 478.987 273.19Z",
    fill: "#CC7D61"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M492.402 272.6L492.37 270.146L490.535 271.719L488.304 271.056L489.112 273.337L487.765 275.381L490.1 275.218L491.499 277.144L492.133 274.763L494.345 273.909L492.402 272.6Z",
    fill: "#CC7D61"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChurch4);
export default __webpack_public_path__ + "static/media/church_4.c28ae089840e71333de5db066e5f6ec5.svg";
export { ForwardRef as ReactComponent };